<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date/index'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import bookingDetailsMixin from '@/mixins/bookingDetailsMixin'
import BookingPendingApprovalsListNonConsecutiveDatesShape from '../pendingApprovals/booking-pending-approvals-list-non-consecutive-dates-shape.vue'
import BookingDetailsActionBtn from './booking-details-action-btn.vue'

export default {
  name: 'BookingDetailsHeaderCard',
  components: {
    BookingPendingApprovalsListNonConsecutiveDatesShape,
    BookingDetailsActionBtn,
  },
  mixins: [baseMixin, bookingDetailsMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isABookingRequest() {
      return this.isBookingRequest(this.booking.status)
    },
    bookingDate() {
      const earliestDate = dayjs(this.booking.details.earliestDate).format(
        DateFormatToken.LL
      )

      // Check if request only contains a single date
      if (
        this.booking.details.earliestDate === this.booking.details.latestDate
      ) {
        return earliestDate
      }

      const latestDate = dayjs(this.booking.details.latestDate).format(
        DateFormatToken.LL
      )

      return `${earliestDate} - ${latestDate}`
    },
    bookingTimeString() {
      return `${dayjs(
        this.booking.details.startTime,
        DateFormatToken.HHmm
      ).format(DateFormatToken.LT)} - ${dayjs(
        this.booking.details.endTime,
        DateFormatToken.HHmm
      ).format(DateFormatToken.LT)}`
    },
    compButtonText() {
      return ''
    },
    compIdText() {
      return this.isBookingRequest
        ? `REF#${this.booking.id}`
        : `#${this.booking.id}`
    },
  },
  methods: {
    handleEvent(payload) {
      this.$emit('actionEvent', payload)
    },
  },
}
</script>

<template>
  <v-alert class="rounded-lg mt-2 grey lighten-4">
    <v-row :class="['align-center py-2', isDarkMode ? '' : 'black--text']">
      <v-col cols="12" md="8" sm="12">
        <div class="d-flex">
          <h3 class="font-weight-medium" data-testid="booking-date-text">{{
            bookingDate
          }}</h3>
          <BookingPendingApprovalsListNonConsecutiveDatesShape
            v-if="!booking.details.areDatesConsecutive"
            class="ml-2"
            style="margin-top: 2px;"
          />
        </div>

        <p class="mt-2 mb-0">{{ bookingTimeString }}</p>
        <p class="mb-0 mt-2 opacity-8">{{
          booking.details.classification.onlineTitle
        }}</p>
        <p class="mb-0 mt-2 opacity-8">{{ compIdText }}</p>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
        :class="[isLargeOrHigher ? 'text-right' : '']"
      >
        <BookingDetailsActionBtn
          :booking="booking"
          @actionEvent="handleEvent"
        />
      </v-col>
    </v-row>
  </v-alert>
</template>
